import httpClient from '@/api/http-client';

const endpoint = 'api/background-checks';

const backgroundChecksService = {
  getPage: (params) => httpClient.get(endpoint, { params }),

  getById: (id) => httpClient.get(`${endpoint}/${id}`),

  create: (backgroundCheck) => httpClient.post(`${endpoint}`, backgroundCheck),

  update: (backgroundCheck) => httpClient.put(`${endpoint}/${backgroundCheck.id}`, backgroundCheck),

  search: (query) => httpClient.get(`${endpoint}/find/${query}`),

  delete: (backgroundCheck) => httpClient.delete(`${endpoint}/${backgroundCheck.id}`),
};

export default backgroundChecksService;
